import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=16b0f164&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=16b0f164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0f164",
  null
  
)

export default component.exports